module.exports = __webpack_public_path__ + "static/hp-bg-4e2ebfaee78154aa717b471ee577a0a2.jpg";